import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import Div from "@jumbo/shared/Div";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  clearPurchaseItemsByPONo,
  getPurchaseItemsByPONo,
} from "app/redux/actions/inventoryAction";
import { currentdate, dateFun } from "app/utils/constants/functions";
import dayjs from "dayjs";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import InfoIcon from "@mui/icons-material/Info";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ItemDetails from "../ActionComponent/itemDetails";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import Swal from "sweetalert2";
import { supplierList } from "app/services/apis/supplierList";
import { getGstListNoPem } from "app/services/apis/ListApi/gst";

const AddFinishedGoods = () => {
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("supplier_name");
  const [poDetails, setPODetails] = useState({});
  const [isInfoModalOpen, setInfoModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [gstList, setGstList] = useState([]);
  const [poList, setPOList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [supplierNameList, setSupplierNameList] = useState([]);
  const [resetAutocomplete, setResetAutocomplete] = useState(false);
  const [supplierType, setSupplierType] = useState("Local");
  const [isCalculated, setIsCalculated] = useState(false)
  const [inputs, setInputs] = useState({
    purchase_order_no: "",
    finished_invoice_no: "",
    finished_invoice_date: dateFun(currentdate),
    finished_discount: "",
    finished_discount_value: "",
    finished_invoice_value: "",
    finished_igst: null,
    finished_sgst: null,
    finished_cgst: null,
  });
  const [expenseFieldsForImport, setExpenseFieldsForImport] = useState({
    import_freight: 0,
    import_duty: 0,
    loading_unloading: 0,
    others: 0,
    margin_amount: 0,
  })
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { purchase_items, error } = useSelector(
    (state) => state.inventoryReducer
  );
  // console.log(purchase_items);
  // Replace this with your actual data

  const headings = [
    "Supplier Name",
    "Supplier Address",
    "Supplier City Pincode",
    "Supplier GST",
    "Contact Person Name",
    "Contact Person Phone No",
    "Contact Person Email ID",
  ];

  const itemDetailsheadings = [
    "Item Name",
    "Size",
    "Qty",
    "Units",
    "Rate per Unit",
    "Amount",
    "GST%",
    "GST",
    "Total Amount",
    "Received Qty Status",
    "Action",
  ];

  const sortedData = poDetails?.purchase_items_details?.sort((a, b) => {
    const aValue = a[orderBy];
    const bValue = b[orderBy];
    if (order === "desc") {
      return aValue < bValue ? -1 : 1;
    } else {
      return bValue < aValue ? -1 : 1;
    }
  });

  const handlePurchaseOrderNo = async (newvalue) => {
    inputs.purchase_order_no = newvalue ? newvalue : "";
    if (newvalue != null) {
      dispatch(getPurchaseItemsByPONo(newvalue));
    }
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (name === "finished_discount") {
      const discountValue = (inputs.assessible * (Number(value) / 100)).toFixed(
        2
      );
      setInputs((values) => ({
        ...values,
        finished_discount_value: discountValue,
      }));
    } else if (name === "gst") {
      let equalValue =
        poDetails?.supplier_master?.supplier_state === "Maharashtra"
          ? (value / 2).toFixed(2)
          : 0;
      const gstValue =
        (inputs.assessible - inputs.finished_discount_value) *
        (Number(value) / 100);
      const invoiceValue =
        inputs.assessible - inputs.finished_discount_value + gstValue;
      setInputs((values) => ({
        ...values,
        finished_invoice_value: Math.round(invoiceValue),
        gst_value: Number(gstValue).toFixed(2),
        finished_sgst: equalValue > 0 ? equalValue : 0,
        finished_cgst: equalValue > 0 ? equalValue : 0,
        finished_igst: equalValue === 0 ? value : 0,
      }));
    }
    setInputs((values) => ({
      ...values,
      [name]:
        name === "finished_invoice_no" || name === "purchase_order_no"
          ? value
          : Number(value),
    }));
  };

  const handleItemAction = (menuItem) => {
    switch (menuItem.action) {
      case "itemDetails":
        setInfoModalOpen(true);
        setSelectedRowData(menuItem.data);
        break;
      default:
        return
    }
  };
  // console.log(purchase_items);
  const submitForm = async () => {
    try {
      const itemData = [];
      // for (let i of purchase_items.purchase_items_details) {
      //   if (JSON.parse(localStorage.getItem(i.id))) {
      //     itemData.push(...JSON.parse(localStorage.getItem(i.id)));
      //   }
      // } // previous logic
      for (let i of poDetails.purchase_items_details) {
        if (JSON.parse(localStorage.getItem(i.id))) {
          const data = JSON.parse(localStorage.getItem(i.id)).map((e) => {
            e.finished_cost_details = JSON.stringify(i)
            return e
          })
          itemData.push(...data);
        }
      }
      for (let key in inputs) {
        if (inputs[key] === "") {
          let error = "";
          if (key == "finished_invoice_no") {
            error = "Invoice Number is Required";
          } else if (key == "finished_invoice_date") {
            error = "Invoice Date is Required";
          } else if (key == "finished_discount") {
            error = "Discount is Required";
          } else if (key == "finished_discount_value") {
            error = "Discount Value is Required";
          } else if (key == "finished_invoice_value") {
            error = "Invoice Value is Required";
          } else if (key == "purchase_order_no") {
            error = "Purchase Order No is Required";
          }
          return Swal.fire({
            title: error,
            icon: "error",
          });
        }
      }
      setLoading(true);
      // console.log({
      //   purchase_order_id: purchase_items?.id,
      //   finished_item_details: itemData.length > 0 ? itemData : [],
      //   ...inputs,
      //   finished_assessible: inputs.assessible,
      //   finished_gst: Number(inputs.gst_value),
      //   finished_gst_percentage: inputs.gst,
      // });
      // return;
      const config = {
        withCredentials: true,
        headers: {
          withCredentials: true,
        },
      };
      const data = await axios.post(
        `${process.env.REACT_APP_URL}/api/finished-good-inventory/add-finished-good-inventory`,
        {
          purchase_order_id: purchase_items?.id,
          finished_item_details: itemData.length > 0 ? itemData : [],
          ...inputs,
          finished_assessible: inputs.assessible,
          finished_gst: Number(inputs.gst_value),
          finished_gst_percentage: inputs.gst,
          import_freight: expenseFieldsForImport?.import_freight,
          import_duty: expenseFieldsForImport?.import_duty,
          loading_unloading: expenseFieldsForImport?.loading_unloading,
          others: expenseFieldsForImport?.others,
          margin_amount: expenseFieldsForImport?.margin_amount,
        },
        config
      );
      // console.log(data);
      if (data?.status == 200) {
        localStorage.clear();
        Swal.fire({
          icon: "success",
          title: "Finished Goods Added Successfully",
        });
        navigate("/dashboard/inventory");
      }
    } catch (error) {
      if (error?.response) {
        Swal.fire({
          icon: "error",
          title: error?.response?.data?.message,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  //old way without adding expense 
  const calculateAssessible = () => {
    if (purchase_items?.purchase_items_details?.length > 0) {
      const itemData = [];
      for (let i of purchase_items?.purchase_items_details) {
        if (JSON.parse(localStorage.getItem(i.id))) {
          itemData.push(...JSON.parse(localStorage.getItem(i.id)));
        }
      }

      const totalTakaReceived = {};
      for (const item of itemData) {
        const kcFabricCode = item.po_item_details_id;
        const takaReceivedQuantity = item.finished_item_recieved_quantity;

        if (totalTakaReceived[kcFabricCode]) {
          totalTakaReceived[kcFabricCode] += takaReceivedQuantity;
        } else {
          totalTakaReceived[kcFabricCode] = takaReceivedQuantity;
        }
      }



      let final_assessible = [];
      for (let i in totalTakaReceived) {
        // console.log("i in total tk rc => ", i)
        const calculatedData = purchase_items?.purchase_items_details?.filter(
          (item) => {
            return item.id == i;
          }
        );

        final_assessible.push(
          Number(totalTakaReceived[i]) * Number(calculatedData[0]?.rate_per_unit)
        );
      }
      const assessible_value = final_assessible.reduce((a, item) => {
        return a + item;
      }, 0);
      setInputs((values) => ({
        ...values,
        assessible: assessible_value,
      }));
      setIsCalculated(true)
    }
  };
  const calculateLocalAssessible = () => {
    if (purchase_items?.purchase_items_details?.length > 0) {
      const itemData = [];
      for (let i of purchase_items?.purchase_items_details) {
        if (JSON.parse(localStorage.getItem(i.id))) {
          itemData.push(...JSON.parse(localStorage.getItem(i.id)));
        }
      }

      const totalTakaReceived = {};
      for (const item of itemData) {
        const kcFabricCode = item.po_item_details_id;
        const takaReceivedQuantity = item.finished_item_recieved_quantity;

        if (totalTakaReceived[kcFabricCode]) {
          totalTakaReceived[kcFabricCode] += takaReceivedQuantity;
        } else {
          totalTakaReceived[kcFabricCode] = takaReceivedQuantity;
        }
      }



      let final_assessible = [];
      for (let i in totalTakaReceived) {
        // console.log("i in total tk rc => ", i)
        const calculatedData = purchase_items?.purchase_items_details?.filter(
          (item) => {
            return item.id == i;
          }
        );

        final_assessible.push(
          Number(totalTakaReceived[i]) * Number(calculatedData?.[0]?.rate_per_unit || 0)
        );
      }

      const updatedItems = purchase_items?.purchase_items_details?.map((item) => {
        const itemId = item.id;
        const itemQuantity = totalTakaReceived[itemId] || 0;

        const assessibleValue = itemQuantity * Number(item?.rate_per_unit || 0);

        return {
          ...item,
          expense_amount: 0,
          updated_rate_per_unit: Number(item?.rate_per_unit?.toFixed(2)),
          assessible_value: Number(assessibleValue?.toFixed(2)),
        };
      });
      setPODetails((values) => ({
        ...values,
        purchase_items_details: updatedItems
      }));

      const assessible_value = final_assessible.reduce((a, item) => {
        return a + item;
      }, 0);
      setInputs((values) => ({
        ...values,
        assessible: assessible_value,
      }));
      setIsCalculated(true)
    }
  };

  const handleSupplier = async (newvalue) => {
    setResetAutocomplete((prev) => !prev);
    setPOList([]);
    inputs.supplier_name = newvalue?.supplier_name
      ? newvalue?.supplier_name
      : "";
    if (newvalue != null) {
      try {
        const config = {
          withCredentials: true,
          headers: {
            withCredentials: true,
          },
        };
        const data = await axios.get(
          `${process.env.REACT_APP_URL
          }/api/inventory/list/get-order-no-based-on-supplier?id=${newvalue.id
          }&purchase_order_type=${"Finished Goods".replace(/ /g, "+")}`,
          config
        );
        if (data?.status == 200) {
          setPOList(data?.data?.result);
        }
      } catch (error) {
        // console.log(error);
        return error?.response?.data?.result;
      }
    }
  };

  useEffect(async () => {
    dispatch(clearPurchaseItemsByPONo());
    setGstList(await getGstListNoPem());
    const data = await supplierList(supplierType);
    if (data?.status === 200) {
      setSupplierNameList(data.data.result);
    }
  }, [supplierType]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    setPODetails(purchase_items);
    if (purchase_items?.purchase_finished_goods_inventory_id !== undefined) {
      const data = await axios.get(
        `${process.env.REACT_APP_URL}/api/finished-good-inventory/get-finished-inventory?id=${purchase_items?.purchase_finished_goods_inventory_id}`
      );
      if (data?.status === 200) {
        const res = data?.data?.result;
        const apiRes = {
          finished_invoice_no:
            res.finished_invoice_no == null ? "" : res.finished_invoice_no,
          finished_invoice_date:
            res.finished_invoice_date == null
              ? ""
              : dateFun(res.finished_invoice_date),
          finished_discount:
            res.finished_discount == null ? "" : res.finished_discount,
          finished_discount_value:
            res.finished_discount_value == null
              ? ""
              : res.finished_discount_value,
          finished_invoice_value:
            res.finished_invoice_value == null
              ? ""
              : res.finished_invoice_value,
        };
        setInputs(apiRes);
      }
    }
  }, [purchase_items]);

  const handleExpenseFieldsInputChange = (e) => {
    const { name, value } = e.target;
    setExpenseFieldsForImport({ ...expenseFieldsForImport, [name]: Number(value) });
  }

  //added expense in each item based on quantity
  const calculateImportAssessible = () => {
    if (purchase_items?.purchase_items_details?.length > 0) {
      const itemData = [];
      for (let i of purchase_items?.purchase_items_details) {
        if (JSON.parse(localStorage.getItem(i.id))) {
          itemData.push(...JSON.parse(localStorage.getItem(i.id)));
        }
      }
      console.log(itemData)
      const totalTakaReceived = {};
      for (const item of itemData) {
        const kcFabricCode = item.po_item_details_id;
        const takaReceivedQuantity = item.finished_item_recieved_quantity;

        if (totalTakaReceived[kcFabricCode]) {
          totalTakaReceived[kcFabricCode] += takaReceivedQuantity;
        } else {
          totalTakaReceived[kcFabricCode] = takaReceivedQuantity;
        }
      }

      // console.log("Total Taka Received =>", totalTakaReceived);


      const totalExpense =
        Number(expenseFieldsForImport?.import_duty || 0) +
        Number(expenseFieldsForImport?.import_freight || 0) +
        Number(expenseFieldsForImport?.loading_unloading || 0) +
        Number(expenseFieldsForImport?.others || 0) +
        Number(expenseFieldsForImport?.margin_amount || 0);

      // console.log("Total Expense =>", totalExpense);
      console.log("exp => ", totalExpense)

      const final_assessible = [];
      const updatedItems = purchase_items?.purchase_items_details?.map((item) => {
        const itemId = item.id;
        const itemQuantity = totalTakaReceived[itemId] || 0;
        const itemExpense =
          (itemQuantity / Object.values(totalTakaReceived).reduce((a, b) => a + b, 0)) *
          totalExpense;

        // const updatedRatePerUnit =
        //   (Number(item?.rate_per_unit || 0) * itemQuantity + itemExpense) / itemQuantity;

        //if quantity is zero then rate per unit must be 0
        const updatedRatePerUnit =
          itemQuantity === 0
            ? 0
            : (Number(item?.rate_per_unit || 0) * itemQuantity + itemExpense) / itemQuantity;



        const assessibleValue = itemQuantity * updatedRatePerUnit;
        console.log("accessible val => ", assessibleValue)

        final_assessible.push(assessibleValue);

        return {
          ...item,
          expense_amount: Number(itemExpense.toFixed(2)),
          updated_rate_per_unit: Number(updatedRatePerUnit.toFixed(2)),
          assessible_value: Number(assessibleValue.toFixed(2)),
        };
      });
      // console.log("updateditem => ", updatedItems)
      setPODetails((values) => ({
        ...values,
        purchase_items_details: updatedItems
      }));
      console.log("final => ", final_assessible)
      const assessible_value = final_assessible.reduce((a, item) => a + item, 0);
      console.log("assesible => ", assessible_value)

      // console.log("Updated items with expenses =>", updatedItems);
      // console.log("Updated assessible value =>", assessible_value);

      setInputs((values) => ({
        ...values,
        assessible: assessible_value,
      }));
      setIsCalculated(true)
    }
  };





  // console.log("purchase item => ", purchase_items?.purchase_items_details)

  return (
    <Div>
      <Div
        sx={{ display: "flex", flexWrap: "wrap", width: "100%", gap: 5, mb: 3 }}
      >
        <Div sx={{ width: "45%" }}>
          <Typography variant="h5">Supplier Type</Typography>
          <Select
            fullWidth
            // value={values?.supplier_type}
            value={supplierType}
            size="small"
            onChange={(e, key) => {
              setSupplierType(e?.target?.value);
              setSupplierType(e?.target?.value);
              setInputs({ ...inputs, supplier_name: null, purchase_order_no: null })
              setPODetails(null)
              setPOList(null)
              setIsCalculated(false)
            }}
          >
            {["Local", "Import"]?.map((type) => {
              return (
                <MenuItem value={type} key={type}>
                  {type}
                </MenuItem>
              );
            })}
          </Select>

        </Div>
        <Div sx={{ width: "45%" }}>
          <Typography variant="h5">Supplier Name</Typography>
          <Autocomplete
            size="small"
            id="tags-standard"
            options={supplierNameList || []}
            key={inputs?.supplier_name}
            value={inputs?.supplier_name}
            // getOptionLabel={(option) => option?.supplier_name}
            getOptionLabel={(option) => {
              if (option instanceof Object && !Array.isArray(option)) {
                return option?.supplier_name;
              } else {
                return option;
              }
            }}
            onChange={(e, newValue) => handleSupplier(newValue)}
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option.supplier_name}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
              // placeholder="KC Fabric Code"
              />
            )}
          />
        </Div>
        <Div sx={{ width: "45%" }}>
          <Typography variant="h3">Purchase Order No</Typography>
          <Autocomplete
            size="small"
            id="tags-standard"
            // key={resetAutocomplete ? "reset1" : "normal1"}
            options={poList || []}
            // getOptionLabel={(option) => option}
            getOptionLabel={(option) => {
              if (option instanceof Object && !Array.isArray(option)) {
                return option;
              } else {
                return option;
              }
            }}
            value={inputs.purchase_order_no}
            key={inputs.purchase_order_no}
            onChange={(e, newValue) => handlePurchaseOrderNo(newValue)}
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                {option}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
              // placeholder="KC Fabric Code"
              />
            )}
          />
        </Div>
      </Div>

      {/* purchase order table */}
      <Div sx={{ mt: 4 }}>
        <Typography variant="h3">Purchase Order Details:</Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
                {headings.map((heading) => (
                  <TableCell
                    key={heading}
                    sx={{
                      textAlign: "left",
                      color: "white",
                      minWidth:
                        heading === "Supplier Address" ? "190px" : "140px", // Adjust the width for "Supplier Address" column
                      verticalAlign: "middle",
                    }}
                  >
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ textAlign: "left" }}>
                  {poDetails?.supplier_master?.supplier_name}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {poDetails?.supplier_master?.supplier_address}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {poDetails?.supplier_master?.supplier_pincode}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {poDetails?.supplier_master?.supplier_gst_no}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {poDetails?.supplier_master?.supplier_contact_person_name}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {poDetails?.supplier_master?.supplier_contact_person_phone_no}
                </TableCell>
                <TableCell sx={{ textAlign: "left" }}>
                  {poDetails?.supplier_master?.supplier_contact_person_email_id}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Div>
      <Div sx={{ mt: 4 }}>
        <Typography variant="h3">Item Details:</Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
                {itemDetailsheadings.map((heading) => (
                  <TableCell
                    key={heading}
                    sx={{
                      textAlign: "left",
                      minWidth: "140px",
                      verticalAlign: "middle",
                      color: "white",
                    }}
                  >
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedData?.map((row, i) => (
                <TableRow key={i}>
                  {/* Render your data here based on the new headings */}
                  <TableCell sx={{ textAlign: "left" }}>
                    {row.purchase_item_name}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.purchase_size ? row?.purchase_size : "-"}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row.quantity}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row.unit_name}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.rate_per_unit}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>{row.amount}</TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row.gst_percentage}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>{row.gst}</TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row.total_amount}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row.po_item_status}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    <JumboDdMenu
                      icon={<MoreHorizIcon />}
                      menuItems={[
                        {
                          icon: <InfoIcon />,
                          title: "Item Details",
                          action: "itemDetails",
                          data: row,
                        },
                      ]}
                      onClickCallback={handleItemAction}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Div>

      {supplierType === "Import" && (
        <>
          <Typography variant="h3" mt={4}>Other Expenses:</Typography>
          <Grid container xs={12} columnGap={2} rowGap={1} >
            <Grid item xs={2.9}   >
              <Typography>Import Freight*</Typography>
              <TextField
                fullWidth
                type="number"
                step="0.01"
                size="small"
                name="import_freight"
                value={expenseFieldsForImport?.import_freight}
                onChange={(e) => handleExpenseFieldsInputChange(e)}
                onBlur={() => setIsCalculated(false)}
                sx={{ width: "100%" }}
              ></TextField>
            </Grid>
            <Grid item xs={2.9} >
              <Typography>Import Duty*</Typography>
              <TextField
                fullWidth
                type="number"
                step="0.01"
                size="small"
                name="import_duty"
                onBlur={() => setIsCalculated(false)}
                value={expenseFieldsForImport?.import_duty}
                onChange={(e) => handleExpenseFieldsInputChange(e)}
                sx={{ width: "100%" }}
              ></TextField>
            </Grid>
            <Grid item xs={2.9} >
              <Typography>Loading Unloading*</Typography>
              <TextField
                fullWidth
                type="number"
                step="0.01"
                size="small"
                name="loading_unloading"
                onBlur={() => setIsCalculated(false)}
                value={expenseFieldsForImport?.loading_unloading}
                onChange={(e) => handleExpenseFieldsInputChange(e)}
                sx={{ width: "100%" }}
              ></TextField>
            </Grid>
            <Grid item xs={2.9} >
              <Typography>Others*</Typography>
              <TextField
                fullWidth
                type="number"
                step="0.01"
                size="small"
                name="others"
                value={expenseFieldsForImport?.others}
                onChange={(e) => handleExpenseFieldsInputChange(e)}
                sx={{ width: "100%" }}
              ></TextField>
            </Grid>
            <Grid item xs={2.9} >
              <Typography>Margin Amount*</Typography>
              <TextField
                fullWidth
                type="number"
                step="0.01"
                size="small"
                name="margin_amount"
                value={expenseFieldsForImport?.margin_amount}
                onChange={(e) => handleExpenseFieldsInputChange(e)}
                sx={{ width: "100%" }}
              ></TextField>
            </Grid>
          </Grid>
          {/* <Grid container xs={12} justifyContent="flex-end" mt={2}  >
            <Button size="small" variant="contained" >Calculate Expenses</Button>
          </Grid> */}
        </>)
      }

      <Div sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <Button variant="contained" size="small" onClick={supplierType === "Local" ? calculateLocalAssessible : calculateImportAssessible}>
          Calculate Assessible
        </Button>
      </Div>
      <Div
        sx={{
          display: "flex",
          flexWrap: "wrap",
          mt: 5,
          width: "100%",
          columnGap: 3,
          rowGap: 1,
        }}
      >
        <Div sx={{ width: "8%" }}>
          <Typography>Invoice Number</Typography>
          <TextField
            size="small"
            name="finished_invoice_no"
            value={inputs.finished_invoice_no}
            onChange={handleChange}
            sx={{ width: "100%" }}
          ></TextField>
        </Div>
        <Div sx={{ width: "8%" }}>
          <Typography>Invoice Date</Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              sx={{
                width: "100%",
                "&.MuiTextField-root": {
                  height: "39px",
                  flexDirection: "unset",
                },
              }}
              format="DD/MM/YY"
              value={
                inputs.finished_invoice_date
                  ? dayjs(inputs.finished_invoice_date)
                  : dayjs(currentdate)
              }
              onChange={(date) => {
                setInputs({ ...inputs, finished_invoice_date: dateFun(date) });
              }}
            />
          </LocalizationProvider>
        </Div>
        <Div sx={{ width: "8%" }}>
          <Typography>Assessible</Typography>
          <TextField
            size="small"
            name="assessible"
            value={inputs.assessible}
            onChange={handleChange}
            sx={{ width: "100%" }}
          ></TextField>
        </Div>
        <Div sx={{ width: "8%" }}>
          <Typography>Discount(%)</Typography>
          <TextField
            size="small"
            type="number"
            name="finished_discount"
            value={inputs.finished_discount}
            onChange={handleChange}
            sx={{ width: "100%" }}
          ></TextField>
        </Div>
        <Div sx={{ width: "8%" }}>
          <Typography>Discount Value</Typography>
          <TextField
            size="small"
            name="finished_discount_value"
            value={inputs.finished_discount_value}
            onChange={handleChange}
            sx={{ width: "100%" }}
          ></TextField>
        </Div>
        <Div sx={{ width: "8%" }}>
          <Typography>GST%</Typography>
          <Select
            name="gst"
            value={inputs?.gst}
            onChange={handleChange}
            fullWidth
            size="small"
          >
            {gstList?.map((gst) => {
              return <MenuItem value={gst}>{gst}%</MenuItem>;
            })}
          </Select>
        </Div>
        {poDetails?.supplier_master?.supplier_state == "Maharashtra" ? (
          <>
            <Div sx={{ width: "8%" }}>
              <Typography>CGST%</Typography>

              <TextField
                size="small"
                sx={{ width: "100%" }}
                name="cgst"
                disabled={true}
                value={inputs?.finished_cgst}
              />
            </Div>

            <Div sx={{ width: "8%" }}>
              <Typography>SGST%</Typography>
              <TextField
                size="small"
                sx={{ width: "100%" }}
                name="sgst"
                disabled={true}
                value={inputs?.finished_sgst}
              />
            </Div>
          </>
        ) : (
          <Div sx={{ width: "8%" }}>
            <Typography>IGST%</Typography>
            <TextField
              size="small"
              sx={{ width: "100%" }}
              name="igst"
              disabled={true}
              value={inputs?.finished_igst}
            />
          </Div>
        )}
        <Div sx={{ width: "8%" }}>
          <Typography>GST Value</Typography>
          <TextField
            size="small"
            name="gst_value"
            disabled
            value={inputs.gst_value}
            sx={{ width: "100%" }}
          ></TextField>
        </Div>

        <Div sx={{ width: "8%" }}>
          <Typography>Invoice Value</Typography>
          <TextField
            size="small"
            name="finished_invoice_value"
            value={inputs.finished_invoice_value}
            onChange={handleChange}
            sx={{ width: "100%" }}
          ></TextField>
        </Div>

        <ItemDetails
          open={isInfoModalOpen}
          onClose={() => setInfoModalOpen(false)}
          rowData={selectedRowData}
          purchaseNo={poDetails?.id}
          type="finishedGoods"
        />
      </Div>

      <Div
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 3,
          mt: 4,
        }}
      >
        <Button
          variant="outlined"
          onClick={() => {
            Swal.fire({
              title: "Are you sure you want to cancel?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes",
              cancelButtonText: "No",
            }).then((result) => {
              if (result.isConfirmed) {
                navigate("/dashboard/inventory");
              }
            });
          }}
        >
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          sx={{ width: "100px" }}
          onClick={submitForm}
          loading={isLoading}
          disabled={isCalculated === false}
        >
          Save
        </LoadingButton>
      </Div>
    </Div>
  );
};

export default AddFinishedGoods;
